export default class FormErrors {
  constructor(jsonApiErrors) {
    this.jsonApiErrors = jsonApiErrors || []
  }

  get messages() {
    return this.jsonApiErrors.map((error) => error.detail)
  }

  get titles() {
    return this.jsonApiErrors.map((error) => error.title)
  }

  get genericMessages() {
    return this.generic.map((error) => error.detail)
  }

  get hasAny() {
    return this.jsonApiErrors.length > 0
  }

  get generic() {
    return this.jsonApiErrors.filter((error) => typeof error.source !== 'object')
  }

  hasError(field) {
    return this.errorsByField(field).length > 0
  }

  messagesFor(field) {
    return this.errorsByField(field).map((error) => error.detail)
  }

  errorsByField(field) {
    const dasherizedField = FormErrors.dasherize(field)

    return this.jsonApiErrors.filter((error) => {
      const source = error.source || { pointer: '' }

      return source.pointer === `/data/attributes/${dasherizedField}`
    })
  }

  static dasherize(field) {
    return field.replace(/([A-Z])/g, '-$1').toLowerCase()
  }
}
